"use client";

// "This grant will provide …" — the plain-English scope of the pending grant.
// Company-wide levels get a building icon, single-contact a person icon, so the
// blast radius is visible before the admin clicks Grant.
// Split out of GrantClientAccessModal.tsx (module-size).

import { Building2, User as UserIcon } from "lucide-react";
import { isCompanyWideAccessLevel } from "@/lib/auth/access-levels";
import type { AccessLevel } from "@/lib/types/database";

export function GrantScopePreview({
  accessLevel,
  text,
}: {
  accessLevel: AccessLevel;
  text: string;
}) {
  const companyWide = isCompanyWideAccessLevel(accessLevel);

  return (
    <div
      className={`rounded-md border px-3 py-2.5 ${
        companyWide
          ? "border-blue-200 bg-blue-50/60 dark:border-blue-900/50 dark:bg-blue-950/25"
          : "border-violet-200 bg-violet-50/50 dark:border-violet-900/50 dark:bg-violet-950/20"
      }`}
      role="status"
      aria-live="polite"
    >
      <p className="text-xs font-medium text-muted-foreground mb-1">This grant will provide</p>
      <div className="flex items-start gap-2">
        {companyWide ? (
          <Building2
            className="mt-0.5 h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400"
            aria-hidden
          />
        ) : (
          <UserIcon
            className="mt-0.5 h-4 w-4 shrink-0 text-violet-600 dark:text-violet-400"
            aria-hidden
          />
        )}
        <p className="text-sm leading-snug">{text}</p>
      </div>
    </div>
  );
}
